import useAppSelector from './useAppSelector'
import { download, selectForm } from '../slices/formSlice'
import { useCallback } from 'react'
import useAppDispatch from './useAppDispatch'
import { toBlob, toCanvas } from '../utils/File'

async function post<InputData extends Object, ReturnData extends Object>(
    url: string,
    body: InputData,
): Promise<{ success: boolean; data: ReturnData; skip?: boolean }> {
    if (!global.ichgehwaehleneuropawahl2024_configuration) {
        console.log('Beaming up the following: ', body)
        return Promise.resolve({ success: true, skip: true, data: {} as ReturnData })
    }

    const formData = new FormData()
    Object.entries(body).forEach(([key, item]) => {
        if (item === null) return

        if (typeof item === 'object' && item instanceof File) {
            formData.append(key, item, item.name)
        } else if (typeof item === 'object' && item instanceof Blob) {
            formData.append(key, item)
        } else {
            formData.append(key, `${item}`)
        }
    })
    const response = await fetch(global.ichgehwaehleneuropawahl2024_configuration.api_url + url, {
        method: 'POST',
        mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            // 'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
    })

    return (await response.json()) as { success: boolean; data: ReturnData }
}

function usePost() {
    const { name, quote, statement, image, downloaded, email } = useAppSelector(selectForm)
    const dispatch = useAppDispatch()

    return useCallback(
        async (data: string[]) => {
            let tile
            if (downloaded) return Promise.resolve()

            const body = {
                name,
                quote,
                statement,
                email,
            }

            const {
                success,
                data: { item },
                skip,
            } = await post<typeof body, { item: string }>('/create_tile', body)

            if (!success) {
                return Promise.reject({ success: false, tile: undefined })
            }

            if (!skip) {
                const images = data.map(async (tileImg, i) =>
                    post<{ item: string; type: 'tile0' | 'tile1' | 'image'; file: Blob }, { url: string }>(
                        '/upload_image',
                        {
                            item,
                            type: i === 0 ? 'tile0' : 'tile1',
                            file: await toBlob(tileImg),
                        },
                    ),
                )
                if (image) {
                    images.push(
                        post<{ item: string; type: 'tile' | 'image'; file: Blob }, { url: string }>('/upload_image', {
                            item,
                            type: 'image',
                            file: await toBlob(image),
                        }),
                    )
                }

                const resolvedImages = await Promise.all(images)

                if (resolvedImages.some(({ success }) => !success)) {
                    return Promise.reject({ success: false, tile: undefined })
                }

                const [
                    {
                        data: { url },
                    },
                ] = resolvedImages
                tile = url
            }

            if (success) {
                dispatch(download())
            }
            return { success, tile }
        },
        [name, quote, statement, image, downloaded, dispatch, email],
    )
}

export default usePost
